import type { ReactElement } from "react";

import { PlainTooltip } from "@similarweb/ui-components";

import WrappedWithQuotaTooltip from "app/pages/sales-intelligence/common-components/WrappedWithQuotaTooltip/WrappedWithQuotaTooltip";

import type { ListIconButtonProps } from "./ListIconButton";
import ListIconButton from "./ListIconButton";

type ListIconButtonContainerProps = ListIconButtonProps & {
    isListSizeQuotaReached: boolean;
    isTrialTooltip?: boolean;
    limitOfWebsitesToTrack?: number;
    tooltipContent?: ReactElement;
    buttonText?: string | number;
};

const ListIconButtonTooltipContainer = (props: ListIconButtonContainerProps) => {
    const { isListSizeQuotaReached, isTrialTooltip, limitOfWebsitesToTrack, tooltipContent, ...rest } = props;

    if (isListSizeQuotaReached) {
        return (
            <WrappedWithQuotaTooltip
                isListSizeQuotaReached
                quotaLimit={limitOfWebsitesToTrack}
                isTrialTooltip={isTrialTooltip}
            >
                <ListIconButton {...rest} />
            </WrappedWithQuotaTooltip>
        );
    }

    if (!tooltipContent) {
        return (
            <div>
                <ListIconButton {...rest} />
            </div>
        );
    }

    return (
        <PlainTooltip
            placement="bottom"
            enabled={!props.isDisabled}
            cssClass="PlainTooltip-element PlainTooltip-element--header"
            tooltipContent={tooltipContent}
        >
            <div>
                <ListIconButton {...rest} />
            </div>
        </PlainTooltip>
    );
};

export default ListIconButtonTooltipContainer;
